module.exports = __webpack_public_path__ + "static/media/homecoming.963670f1.jpg";